(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["widestep-built-different"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAccordion(acc) {
    var items = [].slice.call(acc.querySelectorAll('.bd-item'));
    items.forEach(function (item) {
      var btn = item.querySelector('.bd-item__btn');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('active');
        items.forEach(function (o) {
          o.classList.remove('active');
          var b = o.querySelector('.bd-item__btn');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('active');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
  function init() {
    [].forEach.call(document.querySelectorAll('.bd-accordion'), initAccordion);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    [].forEach.call(e.target.querySelectorAll('.bd-accordion'), initAccordion);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["widestep-comfort-matrix"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initComfortMatrix(root) {
    if (!root || root.dataset.comfortInit === '1') return;
    root.dataset.comfortInit = '1';

    var cols = [].slice.call(root.querySelectorAll('.engineered-comfort-col'));
    if (!cols.length) return;

    function animateCol(col) {
      var pct = col.querySelector('.engineered-comfort-percentage');
      var valEl = col.querySelector('.engineered-comfort-percentage-value');
      var target = parseInt(pct && pct.dataset.percentage, 10) || 0;
      var t0 = null;
      var step = function (ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / 1400, 1);
        if (valEl) valEl.textContent = Math.round(p * target);
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
      col.querySelectorAll('.engineered-comfort-line-fill').forEach(function (f) { f.style.width = '100%'; });
    }

    if (!('IntersectionObserver' in window)) {
      cols.forEach(animateCol);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        animateCol(en.target);
        io.unobserve(en.target);
      });
    }, { threshold: 0.4 });

    cols.forEach(function (c) { io.observe(c); });
  }

  function initAll() {
    [].slice.call(document.querySelectorAll('[data-comfort-matrix]')).forEach(initComfortMatrix);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-comfort-matrix]');
    if (el) initComfortMatrix(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["widestep-countdown-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(bar) {
    if (!bar || bar.dataset.cdInit === '1') return;
    bar.dataset.cdInit = '1';

    var hEl = bar.querySelector('[data-cd-h]');
    var mEl = bar.querySelector('[data-cd-m]');
    var sEl = bar.querySelector('[data-cd-s]');
    if (!hEl || !mEl || !sEl) return;

    var minutes = parseInt(bar.getAttribute('data-cd-minutes'), 10);
    if (isNaN(minutes) || minutes < 1) minutes = 195;
    var durationMs = minutes * 60 * 1000;

    /* Shared key so the announcement countdown bar and the PDP "Offer ends in" timer
       count down to the SAME instant (whichever loads first anchors it for the session). */
    var storageKey = 'wsOfferEnd';
    var endTime;

    try {
      var stored = window.sessionStorage.getItem(storageKey);
      if (stored) {
        endTime = parseInt(stored, 10);
        if (isNaN(endTime) || endTime <= Date.now()) {
          endTime = Date.now() + durationMs;
          window.sessionStorage.setItem(storageKey, String(endTime));
        }
      } else {
        endTime = Date.now() + durationMs;
        window.sessionStorage.setItem(storageKey, String(endTime));
      }
    } catch (e) {
      endTime = Date.now() + durationMs;
    }

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var remaining = endTime - Date.now();
      if (remaining < 0) remaining = 0;
      var totalSec = Math.floor(remaining / 1000);
      var h = Math.floor(totalSec / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;
      hEl.textContent = pad(h);
      mEl.textContent = pad(m);
      sEl.textContent = pad(s);
      if (remaining <= 0 && bar._cdTimer) {
        clearInterval(bar._cdTimer);
        bar._cdTimer = null;
      }
    }

    tick();
    bar._cdTimer = setInterval(tick, 1000);
  }

  function initAll() {
    var bars = document.querySelectorAll('.countdown-bar[data-cd-minutes]');
    for (var i = 0; i < bars.length; i++) init(bars[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var bar = e.target.querySelector('.countdown-bar[data-cd-minutes]');
    if (bar) init(bar);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var bar = e.target.querySelector('.countdown-bar[data-cd-minutes]');
    if (bar && bar._cdTimer) {
      clearInterval(bar._cdTimer);
      bar._cdTimer = null;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["widestep-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(section) {
    if (!section || section.dataset.crpInit === "1") return;
    section.dataset.crpInit = "1";

    var tablist = section.querySelector('[role="tablist"]');
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[role="tab"]'));
    var beforeImg = section.querySelector(".crp-half--before .crp-photo-img");
    var afterImg = section.querySelector(".crp-half--after .crp-photo-img");
    var combinedImg = section.querySelector(".crp-photo-img--combined");
    var panel = section.querySelector(".crp-card");
    var rowCells = Array.prototype.slice.call(section.querySelectorAll(".crp-td[data-area]"));

    function updateMedia(tab) {
      if (!tab) return;
      var b = tab.getAttribute("data-before") || "";
      var a = tab.getAttribute("data-after") || "";
      var c = tab.getAttribute("data-combined") || "";
      // A single pre-split combined image, if present, fills the frame and hides the two halves.
      if (panel) panel.classList.toggle("crp-photos--combined", !!c);
      if (combinedImg) { if (c) { combinedImg.hidden = false; combinedImg.style.display = ""; combinedImg.src = c; } else { combinedImg.hidden = true; } }
      if (beforeImg && b) { beforeImg.style.display = ""; beforeImg.src = b; }
      if (afterImg && a) { afterImg.style.display = ""; afterImg.src = a; }
    }

    function updateRows(area) {
      rowCells.forEach(function (cell) {
        var a = cell.getAttribute("data-area");
        // Rows with a blank area are shared (always shown); area-tagged rows show only for the active tab.
        cell.hidden = a ? (a !== area) : false;
      });
    }

    function activate(tab, setFocus) {
      tabs.forEach(function (t) {
        var selected = t === tab;
        t.classList.toggle("crp-tab--active", selected);
        t.setAttribute("aria-selected", selected ? "true" : "false");
        t.tabIndex = selected ? 0 : -1;
      });
      if (panel) panel.setAttribute("aria-labelledby", tab.id);
      updateMedia(tab);
      updateRows(tab.getAttribute("data-area"));
      if (setFocus) tab.focus();
    }

    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        activate(tab, false);
      });
    });

    if (tablist) {
      tablist.addEventListener("keydown", function (e) {
        var current = section.querySelector('[role="tab"][aria-selected="true"]');
        var idx = tabs.indexOf(current);
        if (idx === -1) return;
        var next = null;
        switch (e.key) {
          case "ArrowRight":
          case "ArrowDown":
            next = tabs[(idx + 1) % tabs.length];
            break;
          case "ArrowLeft":
          case "ArrowUp":
            next = tabs[(idx - 1 + tabs.length) % tabs.length];
            break;
          case "Home":
            next = tabs[0];
            break;
          case "End":
            next = tabs[tabs.length - 1];
            break;
          default:
            return;
        }
        e.preventDefault();
        activate(next, true);
      });
    }

  }

  function initAll() {
    document.querySelectorAll("[data-crp]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (e) {
    var s = e.target.querySelector("[data-crp]");
    if (s) { s.dataset.crpInit = ""; initSection(s); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["widestep-size-tools"] && !Shopify.designMode) return;
  try {
    
/* ---- Find My Perfect Size (bottom-sheet quiz, auto-selects into bundle) ---- */
(function () {
  'use strict';
  var trigger = document.getElementById('sf-trigger');
  var overlay = document.getElementById('sf-overlay');
  if (!overlay) return;
  var sheet = document.getElementById('sf-sheet');
  var body = document.getElementById('sf-body');
  var bar = document.getElementById('sf-bar');
  var stepLabel = document.getElementById('sf-step-label');
  var triggerLabel = document.getElementById('sf-trigger-label');
  var STORE = 'ws_fit_size';
  var lastFocus = null;
  var C = body.dataset || {};

  var DEFAULT_SIZES = [7, 7.5, 8, 8.5, 9];
  var SIZES = (function () {
    var parsed = String(C.sfSizes || '').split(',').map(function (s) { return Number(String(s).trim()); }).filter(function (n) { return isFinite(n); });
    parsed.sort(function (a, b) { return a - b; });
    return parsed.length ? parsed : DEFAULT_SIZES.slice();
  })();
  function sizeLabel(n) { return String(n); }  /* Number("8.0")->8 already strips the trailing .0 */
  var LABELS = SIZES.map(sizeLabel);
  function snap(score) { for (var i = 0; i < SIZES.length; i++) { if (SIZES[i] >= score) return sizeLabel(SIZES[i]); } return sizeLabel(SIZES[SIZES.length - 1]); }
  function sizeUp(label) { var i = LABELS.indexOf(label); if (i < 0) i = 0; return LABELS[Math.min(i + 1, LABELS.length - 1)]; }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  var answers = {};
  var stepIdx = 0;
  var SFI = {}; try { SFI = JSON.parse(document.getElementById('sf-icon-data').textContent); } catch (e) {}
  function sfImg(u) { return u ? '<img src="' + u + '" alt="" decoding="async">' : ''; }
  function sfAv(u) { return u ? '<i style="background-image:url(' + u + ')"></i>' : '<i></i>'; }  /* fitter avatar circle; falls back to the gradient tile */
  var FOOT_N = sfImg(SFI.foot_narrow);
  var FOOT_M = sfImg(SFI.foot_medium);
  var FOOT_W = sfImg(SFI.foot_wide);
  var FOOT_XW = sfImg(SFI.foot_xwide);
  var SOCK_THIN = sfImg(SFI.sock_thin);
  var SOCK_MED = sfImg(SFI.sock_everyday);
  var SOCK_THICK = sfImg(SFI.sock_thick);
  var STEPS = [
    { key: 'size', q: C.sfQ1, help: C.sfHelp1, layout: 'size' },
    { key: 'width', q: C.sfQ2, help: C.sfHelp2, layout: 'cards', options: [
      { icon: FOOT_N, label: C.sfW1 || 'Narrow', value: 'narrow' },
      { icon: FOOT_M, label: C.sfW2 || 'Medium', value: 'medium' },
      { icon: FOOT_W, label: C.sfW3 || 'Wide', value: 'wide' },
      { icon: FOOT_XW, label: C.sfW4 || 'Extra wide', value: 'xwide' } ] },
    { key: 'socks', q: C.sfQ3, help: C.sfHelp3, layout: 'list', options: [
      { icon: SOCK_THIN, label: C.sfS1 || 'Bare feet or thin socks', value: 'thin' },
      { icon: SOCK_MED, label: C.sfS2 || 'Everyday socks', value: 'everyday' },
      { icon: SOCK_THICK, label: C.sfS3 || 'Thick or cushioned socks', value: 'thick' } ] }
  ];

  function getSize() { try { return localStorage.getItem(STORE); } catch (e) { return null; } }
  function saveSize(s) { try { localStorage.setItem(STORE, s); } catch (e) {} updateTrigger(s); }
  function updateTrigger(s) { if (s && triggerLabel && trigger) { triggerLabel.textContent = 'Your fit: ' + s; trigger.classList.add('is-set'); } }

  function activeBody() {
    var r = document.querySelector('.custom-bundle__radio:checked');
    var card = r ? r.closest('product-bundle-card, .custom-bundle') : null;
    return card ? card.querySelector('[data-bundle-body]') : null;
  }
  /* Bundle pills on some products are valued "US 8" while the quiz recommends "8" — an exact
     [value="8"] selector never matched, so the result CTA silently did nothing. Compare on the
     bare numeric part so "8" and "US 8" both resolve to the same pill. */
  function normSize(s) { return String(s).replace(/^\s*us\s*/i, '').trim(); }
  function applySize(size) {
    var bd = activeBody();
    if (!bd) { saveSize(size); return; }
    var want = normSize(size);
    [].forEach.call(bd.querySelectorAll('.custom-bundle__item'), function (item) {
      var input = null;
      [].forEach.call(item.querySelectorAll('.custom-bundle__option--pill input'), function (inp) {
        if (!input && normSize(inp.value) === want) input = inp;
      });
      if (input) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    saveSize(size);
    bd.classList.add('sf-flash');
    setTimeout(function () { bd.classList.remove('sf-flash'); }, 1200);
  }

  function setProgress(n) {
    var pct = n === 'done' ? 100 : n === 0 ? 7 : (n / 3) * 100;
    bar.style.width = pct + '%';
    var step1 = stepLabel.getAttribute('data-step1') || (C.sfStep1Label || 'Step 1 of 3');
    stepLabel.textContent = n === 'done' ? (C.sfYourSize || 'Your fit') : n === 0 ? 'Fit finder' : 'Step ' + n + ' of 3';
  }

  function opt(icon, label, sub, selected, onClick, kind) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sf-opt sf-opt--' + kind + (selected ? ' is-selected' : '');
    var inner = (kind === 'tile') ? '' : '<span class="sf-opt__ic" aria-hidden="true">' + (icon || '') + '</span>';
    inner += '<span class="sf-opt__label">' + esc(label) + (sub ? ' <span class="sf-opt__sub">' + esc(sub) + '</span>' : '') + '</span>';
    if (kind === 'list') inner += '<span class="sf-opt__check" aria-hidden="true"></span>';
    b.innerHTML = inner;
    b.addEventListener('click', onClick);
    return b;
  }

  function pick(btn, fn) {
    if (body.classList.contains('sf-busy')) return;
    [].forEach.call(body.querySelectorAll('.sf-opt'), function (o) { if (o !== btn) o.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    body.classList.add('sf-busy');
    setTimeout(fn, 300);
  }

  function renderIntro() {
    setProgress(0);
    body.scrollTop = 0;
    body.innerHTML =
      '<div class="sf-intro">' +
        '<div class="sf-intro__badge" aria-hidden="true">' + sfImg(SFI.badge) + '</div>' +
        '<h2 class="sf-intro__h" id="sf-q">' + esc(C.sfIntroH) + '</h2>' +
        '<p class="sf-intro__p">' + esc(C.sfIntroP) + '</p>' +
        '<div class="sf-intro__trust">' +
          '<div class="sf-intro__stars"><span class="sf-stars">&#9733;&#9733;&#9733;&#9733;&#9733;</span> <strong>' + esc(C.sfRating) + '</strong> ' + esc(C.sfRatingLabel) + '</div>' +
          '<div class="sf-intro__count"><span class="sf-avs" aria-hidden="true">' + sfAv(SFI.fitter1) + sfAv(SFI.fitter2) + sfAv(SFI.fitter3) + '</span> ' + esc(C.sfCountLabel) + '</div>' +
        '</div>' +
        '<button type="button" class="sf-cta sf-intro__start" id="sf-start">' + esc(C.sfStartLabel) + '</button>' +
        '<p class="sf-intro__note">' + esc(C.sfIntroNote) + '</p>' +
      '</div>';
    document.getElementById('sf-start').addEventListener('click', function () { stepIdx = 0; renderStep(); });
  }

  function renderStep() {
    body.classList.remove('sf-busy');
    if (stepIdx < 0) return renderIntro();
    if (stepIdx >= STEPS.length) return renderResult();
    var step = STEPS[stepIdx];
    setProgress(stepIdx + 1);
    body.scrollTop = 0;
    body.innerHTML = '';
    var h = document.createElement('h2'); h.className = 'sf-q'; h.id = 'sf-q'; h.textContent = step.q || '';
    var help = document.createElement('p'); help.className = 'sf-help'; help.textContent = step.help || '';
    body.appendChild(h); body.appendChild(help);
    if (step.layout === 'size') {
      var grid = document.createElement('div'); grid.className = 'sf-grid';
      SIZES.forEach(function (sz) {
        grid.appendChild(opt('', sizeLabel(sz), '', answers.size === sz, function (e) {
          answers.size = sz; pick(e.currentTarget, function () { stepIdx++; renderStep(); });
        }, 'tile'));
      });
      body.appendChild(grid);
    } else {
      var cards = step.layout === 'cards';
      var wrap = document.createElement('div'); wrap.className = cards ? 'sf-cards' : 'sf-list';
      step.options.forEach(function (o) {
        wrap.appendChild(opt(o.icon, o.label, o.sub, answers[step.key] === o.value, function (e) {
          answers[step.key] = o.value; pick(e.currentTarget, function () { stepIdx++; renderStep(); });
        }, cards ? 'card' : 'list'));
      });
      body.appendChild(wrap);
    }
    if (stepIdx > 0) {
      var back = document.createElement('button'); back.type = 'button'; back.className = 'sf-back'; back.textContent = C.sfBackLabel || 'Back';
      back.addEventListener('click', function () { stepIdx--; renderStep(); });
      body.appendChild(back);
    }
  }

  function recommend() {
    var base = answers.size;
    var nudge = 0;
    if (answers.width === 'xwide') nudge += 0.5;
    if (answers.socks === 'thick') nudge += 0.5;
    return snap(base + Math.min(nudge, 0.5));
  }

  function renderResult() {
    setProgress('done');
    var size = recommend();
    var nudged = answers.width === 'xwide' || answers.socks === 'thick';
    var conf = nudged ? 95 : 97;
    var widthMap = { narrow: 'Narrow feet, snug and secure where it counts.', medium: 'Medium width, true to your size.', wide: 'Wide feet, our roomy toe box has you covered.', xwide: 'Extra wide feet, we left room so nothing pinches.' };
    var sockMap = { thin: 'Thin socks, no extra room needed.', everyday: 'Everyday socks, factored in.', thick: 'Thick socks, we left room for them.' };
    var chk = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none"><path d="M5 12.5l4.2 4.2L19 7.2" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    function li(t) { return '<li><span class="sf-why__c" aria-hidden="true">' + chk + '</span><span>' + esc(t) + '</span></li>'; }
    var matchTpl = (C.sfResultSub || '<strong>{conf}%</strong> fit match for your feet');
    var whyH = (C.sfWhyH || 'Why size {size}').replace('{size}', esc(size));
    var ctaTpl = (C.sfCta || 'Add size {size} to my order').replace('{size}', esc(size));
    body.scrollTop = 0;
    body.innerHTML =
      '<div class="sf-result">' +
        '<p class="sf-result__eyebrow">' + esc(C.sfResultEyebrow) + '</p>' +
        '<div class="sf-ring">' +
          '<svg class="sf-ring__svg" viewBox="0 0 128 128" aria-hidden="true"><circle class="sf-ring__bg" cx="64" cy="64" r="54"/><circle class="sf-ring__fg" cx="64" cy="64" r="54"/></svg>' +
          '<div class="sf-ring__c"><span class="sf-ring__size" id="sf-q">' + esc(size) + '</span><span class="sf-ring__sub">' + esc(C.sfYourSize || 'your size') + '</span></div>' +
        '</div>' +
        '<p class="sf-result__match">' + matchTpl.replace('{conf}', conf) + '</p>' +
        '<div class="sf-why"><p class="sf-why__h">' + whyH + '</p><ul class="sf-why__list">' +
          li('You usually wear a ' + answers.size + '.') +
          li(widthMap[answers.width] || 'Matched to our foot shaped fit.') +
          li(sockMap[answers.socks] || 'Sock thickness factored in.') +
        '</ul></div>' +
        '<p class="sf-result__expect">' + esc(C.sfExpect) + '</p>' +
        '<div class="sf-result__assure"><span class="sf-result__assure-ic" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none"><path d="M12 3l7 3v5c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6l7-3Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M9 12l2 2 4-4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span>' + esc(C.sfAssure) + '</span></div>' +
        '<p class="sf-result__proof">' + esc(C.sfProof) + '</p>' +
        '<button type="button" class="sf-cta" id="sf-cta">' + ctaTpl + '</button>' +
        '<button type="button" class="sf-sizeup" id="sf-up">' + esc(C.sfSizeup) + '</button>' +
        '<button type="button" class="sf-restart" id="sf-restart">' + esc(C.sfRestart) + '</button>' +
      '</div>';
    var fg = body.querySelector('.sf-ring__fg');
    if (fg) { var CR = 2 * Math.PI * 54; fg.style.strokeDasharray = CR; fg.style.strokeDashoffset = CR; requestAnimationFrame(function () { requestAnimationFrame(function () { fg.style.strokeDashoffset = CR * (1 - conf / 100); }); }); }
    document.getElementById('sf-cta').addEventListener('click', function () { applySize(size); close(); goBundle(); });
    document.getElementById('sf-up').addEventListener('click', function () { var u = sizeUp(size); applySize(u); close(); goBundle(); });
    document.getElementById('sf-restart').addEventListener('click', function () { answers = {}; stepIdx = 0; renderStep(); });
  }

  function goBundle() {
    var o = document.getElementById('offer');
    if (o) o.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function open() {
    lastFocus = document.activeElement;
    answers = {}; stepIdx = -1;
    overlay.hidden = false;
    renderStep();
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { var f = sheet.querySelector('.sf-opt, button'); if (f) f.focus(); }, 90);
    document.addEventListener('keydown', onKey, true);
  }
  function close() {
    overlay.classList.remove('is-open');
    document.removeEventListener('keydown', onKey, true);
    document.documentElement.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) {
    if (e.key === 'Escape') return close();
    if (e.key === 'Tab') {
      var f = [].filter.call(sheet.querySelectorAll('button'), function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }

  if (trigger) trigger.addEventListener('click', open);
  // Any element marked data-sf-open opens the quiz directly (e.g. the "Find My Size" button).
  [].forEach.call(document.querySelectorAll('[data-sf-open]'), function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); open(); });
  });
  window.sfOpen = open;
  [].forEach.call(overlay.querySelectorAll('[data-sf-close]'), function (el) { el.addEventListener('click', close); });
  overlay.addEventListener('click', function (e) {
    /* close ONLY when the click lands on the scrim/overlay itself. The previous
       !closest('.sf-sheet') check killed the quiz: option clicks re-render the step,
       so by the time the event bubbled here the target was detached and closest() failed. */
    if (e.target === overlay || e.target.classList.contains('sf-scrim')) close();
  });

  // switching bundle tier re-fills the newly revealed pairs from the stored fit
  document.querySelectorAll('.custom-bundle__radio').forEach(function (r) {
    r.addEventListener('change', function () { var s = getSize(); if (s) setTimeout(function () { applySize(s); }, 0); });
  });

  // on load: if the shopper already has a known fit, reflect it on the trigger + bundle
  var saved = getSize();
  if (saved && LABELS.indexOf(saved) > -1) { updateTrigger(saved); applySize(saved); }
})();

/* ---- Size Chart modal (opened by the "Size Chart" button) ---- */
(function () {
  var overlay = document.getElementById('sc-overlay');
  var openBtn = document.getElementById('sh-tab-chart') || document.querySelector('[aria-controls="sc-overlay"]');
  if (!overlay || !openBtn) return;
  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', onKey, true);
    var c = overlay.querySelector('.sc-close');
    if (c) setTimeout(function () { c.focus(); }, 60);
  }
  function close() {
    overlay.classList.remove('is-open');
    document.removeEventListener('keydown', onKey, true);
    document.documentElement.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  openBtn.addEventListener('click', open);
  [].forEach.call(overlay.querySelectorAll('[data-sc-close]'), function (el) { el.addEventListener('click', close); });
  overlay.addEventListener('click', function (e) { if (e.target === overlay || e.target.classList.contains('sc-backdrop')) close(); }); /* scrim-only close (see sf note) */
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["widestep-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var sticky = document.querySelector('[data-ws-sticky-atc]');
    if (!sticky) return;

    // Anchor: the page's main buy box / add-to-cart. On the WideStep PDP the ATC
    // is a plain <button data-ws-atc> (not inside a /cart/add form), so match that
    // first; fall back to a product form's submit button for standalone use.
    var atcBtn =
      document.querySelector('[data-ws-buy-box]') ||
      document.querySelector('[data-ws-atc]') ||
      document.querySelector('product-form button[name="add"]') ||
      document.querySelector('form[action*="/cart/add"] [type="submit"]') ||
      document.querySelector('form[action*="/cart/add"] button[name="add"]');

    var sb = sticky.querySelector('[data-sticky-atc-btn]');

    if (atcBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        /* The sticky ATC (fixed, top:0, z-index 1050) is the scroll-persistent top bar on the PDP
           and covers the header per the design. Flag the root so the fixed site header hides while
           it's up — otherwise both pin at top:0 and the taller header peeks below the ATC. */
        document.documentElement.classList.toggle('ws-satc-on', show);
      }, { threshold: 0 }).observe(atcBtn);

      if (sb) {
        sb.addEventListener('click', function () {
          atcBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["widestep-value-spec"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initSection(section){
    if(section.dataset.vsmInit === '1') return;
    section.dataset.vsmInit = '1';

    var tabs = Array.prototype.slice.call(section.querySelectorAll('.vsm-tab'));
    var altNameEl = section.querySelector('[data-vsm-altname]');
    var markCells = Array.prototype.slice.call(section.querySelectorAll('[data-vsm-mark]'));
    if(!tabs.length) return;

    function iconSVG(kind){
      if(kind === 'check'){
        return '<span class="vsm-icon vsm-yes" role="img" aria-label="Yes">'
          + '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          + '</span>';
      }
      return '<span class="vsm-icon vsm-no" role="img" aria-label="No">'
        + '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.5 6.5l11 11M17.5 6.5l-11 11" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round"/></svg>'
        + '</span>';
    }

    function apply(tab){
      if(altNameEl){ altNameEl.textContent = tab.getAttribute('data-name'); }
      var marks = (tab.getAttribute('data-marks') || '').split(',');
      markCells.forEach(function(cell, i){
        cell.innerHTML = iconSVG(marks[i]);
      });
    }

    function activate(tab, focus){
      tabs.forEach(function(t){
        var on = (t === tab);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      apply(tab);
      if(focus){ tab.focus(); }
    }

    tabs.forEach(function(tab, idx){
      tab.addEventListener('click', function(){ activate(tab, false); });
      tab.addEventListener('keydown', function(e){
        var next = null;
        switch(e.key){
          case 'ArrowRight': next = tabs[(idx + 1) % tabs.length]; break;
          case 'ArrowLeft':  next = tabs[(idx - 1 + tabs.length) % tabs.length]; break;
          case 'Home':       next = tabs[0]; break;
          case 'End':        next = tabs[tabs.length - 1]; break;
          default: return;
        }
        e.preventDefault();
        activate(next, true);
      });
    });

    var initial = tabs.filter(function(t){ return t.classList.contains('is-active'); })[0] || tabs[0];
    apply(initial);
  }

  function initAll(){
    var sections = document.querySelectorAll('.vsm-section');
    Array.prototype.slice.call(sections).forEach(initSection);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function(e){
    var sec = e.target.querySelector('.vsm-section');
    if(sec){ sec.dataset.vsmInit = ''; initSection(sec); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
